'use client';

import { createContext, type ReactNode, useContext } from 'react';

import { useTeamConfig } from '@/app/(football)/[team]/_context/context';

import { storeConfig } from './config';
import type { StorePageConfig } from './types';

const StorePageConfigContext = createContext<StorePageConfig | null>(null);

interface Props {
  children: ReactNode;
}

export function StorePageConfigProvider({ children }: Props) {
  const { teamSlug } = useTeamConfig();
  const config = storeConfig[teamSlug];

  return <StorePageConfigContext.Provider value={config}>{children}</StorePageConfigContext.Provider>;
}

export function useStorePageConfig() {
  const context = useContext(StorePageConfigContext);

  if (!context) {
    throw new Error('useStorePageConfig must be used within StorePageConfigProvider');
  }

  return context;
}
